export class ToyboxRays extends Phaser.GameObjects.Container {
  constructor(scene, x, y) {
    super(scene, x, y);
    scene.add.existing(this);

    const step = 360 / 36;
    for (let i = 0; i < 360; i += step) {
      const rads = Phaser.Math.DegToRad(i);
      const x = 150 * Math.cos(rads);
      const y = 150 * Math.sin(rads);
      const ray = scene.add.image(x, y, 'toybox', 'toybox_ray').setOrigin(0.5, 1);

      ray.angle = i + 90;
      this.add(ray);
    }
  }

  spin(value) {
    if (value) {
      this.scene.tweens.add({
        targets: this,
        angle: { from: 0, to: 360 },
        repeat: -1,
        duration: 60000,
      });
    } else {
      this.scene.tweens.killTweensOf(this);
    }
  }
}
